var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "13px",
        height: "14px",
        viewBox: "0 0 13 14",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("title", [_vm._v("edit")]),
      _vm._v(" "),
      _c(
        "g",
        {
          attrs: {
            id: "Symbols",
            stroke: "none",
            "stroke-width": "1",
            fill: "currentColor",
            "fill-rule": "evenodd",
          },
        },
        [
          _c(
            "g",
            {
              attrs: {
                id: "Edit-link-+-icon-OVER",
                transform: "translate(-48.000000, -8.000000)",
                fill: "currentColor",
              },
            },
            [
              _c(
                "g",
                {
                  attrs: {
                    id: "Group",
                    transform: "translate(48.025796, 8.026572)",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M-2.66453526e-15,9.43037923 L-2.66453526e-15,13 L3.45324487,13 L10.3597346,5.86075847 L6.90648974,2.2911377 L-2.66453526e-15,9.43037923 L-2.66453526e-15,9.43037923 Z M3.01329823,11.9016146 L3.01329823,11.9016146 L2.12505025,11.90172 L2.12505025,10.8033346 L1.06257607,10.8033346 L1.06257607,9.88504695 L1.81796383,9.10420228 L3.768686,11.1206647 L3.01329823,11.9016146 L3.01329823,11.9016146 Z M7.17221017,3.74992911 C7.29386285,3.74992911 7.3546892,3.81291065 7.3546892,3.93866308 C7.3546892,3.99595732 7.33543261,4.04450998 7.29661379,4.08463701 L2.79740038,8.73547593 C2.75868345,8.77539232 2.71161181,8.79540317 2.65628735,8.79540317 C2.53463466,8.79540317 2.47370643,8.73231632 2.47370643,8.60666921 C2.47370643,8.54937496 2.4930649,8.50082231 2.53178184,8.46069528 L7.03099525,3.80996168 C7.06971218,3.76993997 7.11678382,3.74992911 7.17221017,3.74992911 L7.17221017,3.74992911 Z",
                      id: "Shape",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      d: "M12.268887,2.33389774 L10.3181648,0.326071634 C10.1079726,0.108795865 9.8561088,-1.99255125e-15 9.56277708,-1.99255125e-15 C9.2638416,-1.99255125e-15 9.01493247,0.108795865 8.81574403,0.326071634 L7.43782872,1.74189236 L10.8910736,5.31151313 L12.2690908,3.88716146 C12.473883,3.67546766 12.5761772,3.41806486 12.5761772,3.11484773 C12.5760753,2.81742322 12.4737811,2.55707145 12.268887,2.33389774 L12.268887,2.33389774 Z",
                      id: "Shape",
                    },
                  }),
                ]
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }